var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card","closable":""},on:{"tab-remove":_vm.removeTab,"tab-click":_vm.change},model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},_vm._l((_vm.tabs),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.label,"name":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }